import React, { useState } from "react";
import styled from "@emotion/styled";
import { track } from "../../utils/track";

/** 합주방 띠 (악보 위). 방장: 링크 보내기·방 닫기 / 들어온 사람: 방장 화면을 따라가는 중 */
const EnsembleBar: React.FC<{
  isHost: boolean;
  hostName: string;
  closed: boolean;
  link: string;
  onClose: () => void;
  onLeave: () => void;
}> = ({ isHost, hostName, closed, link, onClose, onLeave }) => {
  const [copied, setCopied] = useState(false);

  const share = async () => {
    track("ensemble:share");
    const text = `코드스코어 합주방에 들어오세요. 같은 악보가 같이 넘어가요.\n${link}`;
    const ua = navigator.userAgent;
    if (/chordscore\/Android/.test(ua) && (window as any).chordscore) {
      (window as any).chordscore.postMessage(JSON.stringify({ type: "share", text }));
      return;
    }
    if (/chordscore\/iOS/.test(ua) && (window as any).webkit?.messageHandlers?.shareHandler) {
      (window as any).webkit.messageHandlers.shareHandler.postMessage(link);
      return;
    }
    if ((navigator as any).share) {
      try {
        await (navigator as any).share({ title: "코드스코어 합주방", text, url: link });
        return;
      } catch (e) {
        if ((e as any)?.name === "AbortError") return;
      }
    }
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      window.prompt("이 링크를 복사해 보내 주세요", link);
    }
  };

  if (closed) {
    return (
      <Bar>
        <Dot off />
        <Text>
          <b>합주방이 닫혔어요</b>
          <span>이제 내 화면으로 볼 수 있어요</span>
        </Text>
        <Ghost type="button" onClick={onLeave}>확인</Ghost>
      </Bar>
    );
  }

  return (
    <Bar>
      <Dot />
      <Text>
        <b>{isHost ? "합주방을 열었어요" : `${hostName}님의 합주방`}</b>
        <span>{isHost ? "링크로 들어온 사람은 내 화면(재생·속도·키)을 같이 봐요" : "방장 화면을 따라 같이 넘어가요"}</span>
      </Text>
      {isHost ? (
        <>
          <Primary type="button" onClick={share}>{copied ? "복사됨" : "링크 보내기"}</Primary>
          <Ghost type="button" onClick={() => { track("ensemble:close"); onClose(); }}>닫기</Ghost>
        </>
      ) : (
        <Ghost type="button" onClick={onLeave}>나가기</Ghost>
      )}
    </Bar>
  );
};

export default EnsembleBar;

const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 12px 4px;
  padding: 10px 12px;
  border-radius: 14px;
  background: #1c1a14;
  border: 1px solid #4a3a1a;
`;

const Dot = styled.i<{ off?: boolean }>`
  flex: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ off }) => (off ? "#6b7280" : "#3ddc97")};
  box-shadow: ${({ off }) => (off ? "none" : "0 0 0 4px rgba(61,220,151,.18)")};
`;

const Text = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  & > b {
    font-size: 14px;
    color: #f3f4f6;
  }
  & > span {
    font-size: 12px;
    color: #a3a9b5;
    word-break: keep-all;
  }
`;

const Primary = styled.button`
  flex: none;
  height: 34px;
  padding: 0 12px;
  border: 0;
  border-radius: 10px;
  background: #ffb547;
  color: #0d0e12;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
`;

const Ghost = styled.button`
  flex: none;
  height: 34px;
  padding: 0 10px;
  border: 1px solid #3a3f4b;
  border-radius: 10px;
  background: transparent;
  color: #e9ebf0;
  font-size: 13px;
  cursor: pointer;
`;
